<!-- template html -->
<template>
    <div class="gc-booklet" v-if="cover">

        <div class="mt-groupCard" :class="[templateClass, coverTypeClass]">
            <div class="gc-booklet-inner" :style="'height:'+ pageHeight + 'px;'">

                <div class="gc-container">
                    <div class="gc-container-inner" :style="'-webkit-transform: scale(' + defaultScale + ')'">

                        <div class="mt-groupCard-header"></div>
                        <!-- header -->
                        <div class="mt-groupCard-batch4-header edit-message parent-editable">
                            <div class="groupcard-upload-yourown" :class="(!isImageEditable && editable) ? 'cover-editable' : ''" @click="handleDivClick">
                                <div class="image-upload-wrapper" v-show="!cover.ImageUrl" id="image-upload-wrapper">
                                    <div class="position-wrapper">
                                        <input v-if="editable" class="_image_upload_input_" type="file" name="groupcard_cover_image_file" id="groupcard_cover_image_file" hidden="hidden" accept=".jpg, .jpeg, .bmp, .png" style="visibility:hidden !important;" ref="imageInputEdit" @change="loadImageinBoxCover" />
                                        <button class="image-select-btn" @click="editImage">
                                            <span class="select-btn-icon"></span> Upload an image
                                        </button>
                                    </div>
                                    <button class="gif-select-btn" data-toggle="modal" data-target="#giphy-library" @click="handleImageSelectClick">
                                        <span class="select-btn-icon"></span> Select a GIF
                                    </button>
                                </div>

                                <img class="_image_upload_img_ img-fluid cursor-pointer" v-if="cover.ImageUrl" :src="cover.ImageUrl" alt="Group Card Image" @error="onCoverImageError">

                                <button class="delete-image-btn" v-show="cover.ImageUrl" @click="deleteImage">
                                    <span class="select-btn-icon"></span>
                                </button>
                            </div>
                        </div>

                        <!-- mt-groupCard-image-header -->
                        <!-- AI Magic Cover Wrapper -->
                        <div class="ai-magic-cover-wrapper" v-if="templateClass.includes('_ai-magic-cover_')">
                            <div class="ai-magic-cover-btn" :class="{ 'd-none': hasAiMagicCoverImage }">
                                <button type="button" class="ai-select-btn theme-btn-dark" @click="openAiMagicCover(false)">
                                    <span class="select-ai-icon"></span> Create your cover
                                </button>
                            </div>
                            <!-- ai-magic-cover-btn -->
                            <button type="button" class="ai-edit-btn theme-btn-lite" :class="{ 'd-none': !hasAiMagicCoverImage }" @click="openAiMagicCover(true)">
                                <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.81248 28.188C5.95373 29.3292 7.79623 29.3292 8.93748 28.188L26.8125 10.313C27.9537 9.17172 27.9537 7.32922 26.8125 6.18797C25.6712 5.04672 23.8287 5.04672 22.6875 6.18797L4.81248 24.063C3.67123 25.2042 3.67123 27.0467 4.81248 28.188Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M24.7637 12.3613L20.6387 8.23633" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M11.6875 3.355L13.75 2.75L13.145 4.8125L13.75 6.875L11.6875 6.27L9.625 6.875L10.23 4.8125L9.625 2.75L11.6875 3.355Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M6.1875 11.605L8.25 11L7.645 13.0625L8.25 15.125L6.1875 14.52L4.125 15.125L4.73 13.0625L4.125 11L6.1875 11.605Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M26.8125 18.48L28.875 17.875L28.27 19.9375L28.875 22L26.8125 21.395L24.75 22L25.355 19.9375L24.75 17.875L26.8125 18.48Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </button>
                            <!-- ai-edit-btn -->
                            <img class="_image_upload_img_ img-fluid ai-magic-cover-image" :src="cover.ImageUrl || placeholderImageUrl" alt="AI Magic Cover" @error="onCoverImageError" />

                        </div>
                        <!-- ai-magic-cover-wrapper -->

                        <div class="mt-groupCard-title position-relative parent-editable">
                            <div id="gc-cover-div" v-html="editedTitle" :style="'font-size:'+FontSize +';text-align:'+textReAlign" :contenteditable="isCoverEditable" :class="(!isCoverEditable && editable)?'cover-editable':''" @paste="handlePaste" @click="editCoverTitle" @input="onInputCoverEdit($event)" ref="coverDivRef">
                            </div>
                        </div>
                        <!-- title -->

                        <div class="mt-groupCard-space position-relative parent-editable">
                            <div class="mt-groupCard-image">
                                <img v-if="cover.ImageUrl" :src="cover.ImageUrl" alt="Group Card Image" @error="onCoverImageError" />
                            </div>
                            <!-- image -->
                            <div class="mt-groupCard-description">
                                <div id="gc-cover-desc-div" v-html="editedDescription" :style="'font-size:'+descriptionFontSize +';text-align:'+descriptionTextAlign" :contenteditable="isDescEditable" :class="(!isDescEditable && editable)?'cover-editable':''" @click="editCoverDesc" @input="onInputCoverDescEdit($event)" ref="coverDescDivRef">
                                </div>
                            </div>
                            <!-- description -->
                        </div>
                        <!-- mt-groupCard-space -->
                    </div>
                    <!-- gc-container-inner -->
                </div>
                <!-- gc-container -->

                <a v-if="isCoverEditable || isDescEditable || isImageEditable" @click="saveData" href="javascript:void(0);" class="edit-card edit-gc-title" data-toggle="tooltip" data-custom-class="tooltip-custom" data-placement="bottom" title="Save your edits">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                    <path d="M166,332h180c8.284,0,15-6.716,15-15s-6.716-15-15-15H166c-8.284,0-15,6.716-15,15S157.716,332,166,332z" />
                    <path d="M166,392h180c8.284,0,15-6.716,15-15s-6.716-15-15-15H166c-8.284,0-15,6.716-15,15S157.716,392,166,392z" />
                    <path d="M507.606,84.394l-80-80C424.793,1.58,420.978,0,417,0H15C6.716,0,0,6.716,0,15v482c0,8.284,6.716,15,15,15     c6.912,0,477.495,0,482,0c8.284,0,15-6.716,15-15V95C512,91.021,510.419,87.206,507.606,84.394z M121,30h210v100H121V30z      M391,482H121V272h270V482z M482,482h-61V257c0-8.284-6.716-15-15-15H106c-8.284,0-15,6.716-15,15v225H30V30h61v115     c0,8.284,6.716,15,15,15h240c8.284,0,15-6.716,15-15V30h49.787L482,101.213V482z" />
                    <path d="M166,452h180c8.284,0,15-6.716,15-15s-6.716-15-15-15H166c-8.284,0-15,6.716-15,15S157.716,452,166,452z" />
                    </svg>
                </a>
                <!-- save button -->
            </div>
            <!-- mt-groupCard -->
        </div>
        <!-- gc-booklet-inner -->


    </div>
    <!-- gc-booklet-cover -->
</template>
<!-- template html -->
<!-- script -->
<script>
    export default {
        name: 'GroupCardCover',
        props: {
            collection: String,
            cover: Object,
            defaultScale: Number,
            pageHeight: Number,
            editable: Boolean,
            fontResize: String,
            textAlign: String,
            showTitlePlaceholder: {
                type: Boolean,
                default: false,
            },
        },
        data: function () {
            return {
                showCoverDiv: false,
                editedTitle: "",
                editedTitleM: "",
                editedDescription: "",
                editedDescriptionM: "",
                popupType: 0,
                FontSize: "",
                textReAlign: "",
                descriptionTextAlign: "",
                descriptionFontSize: "",
                characterCounter: 0,
                groupCardCoverContainer: "",
                isImageEditable: false,
                placeholderImageUrl: "https://grouptogethersite.blob.core.windows.net/siteres/ai-magic-cover-placeholder.png",
            }
        },
        watch: {
            fontResize: function (val) {
                if (this.isCoverEditable) {
                    var size = $("#gc-cover-div").css('font-size');
                    this.FontSize = (parseInt(size) + val) + "px"
                }
                else if (this.isDescEditable) {
                    var size = $("#gc-cover-desc-div").css('font-size');
                    this.descriptionFontSize = (parseInt(size) + val) + "px"
                }
            },
            textAlign: function (val) { // watch it
                if (this.isCoverEditable) {
                    this.textReAlign = val
                }
                else if (this.isDescEditable) {
                    this.descriptionTextAlign = val
                }

            }
        },
        mounted: function () {
            document.addEventListener('gif-selected', this.handleGifSelected);

            document.addEventListener('click', this.handleClickOutside);

            document.addEventListener('ai-magic-cover-generated', this.handleAiMagicCoverGenerated);

            if (this.cover != null) {
                this.editedTitleM = this.cover.Title
                const isNbspTitle = !this.cover.Title || this.cover.Title.replace(/&nbsp;| |\s/g, '') === ''
                this.editedTitle = isNbspTitle && this.showTitlePlaceholder ? 'Your title here' : this.cover.Title
                this.cover.Title = this.editedTitle
                this.editedDescriptionM = this.editedDescription = this.cover.Description
                this.FontSize = (this.cover.FontSize != null) ? this.cover.FontSize : this.fontResize
                this.textReAlign = (this.cover.TextAlign != null) ? this.cover.TextAlign : this.textAlign
                this.descriptionTextAlign = (this.cover.DescTextAlign != null) ? this.cover.DescTextAlign : this.textAlign
                this.descriptionFontSize = (this.cover.DescFontSize != null) ? this.cover.DescFontSize : this.fontResize
                if (this.descriptionFontSize == 0 || this.descriptionFontSize == "") {
                    var size = $("#gc-cover-desc-div").css('font-size');
                    this.descriptionFontSize = size
                }
                if (this.cover.ImageUrl === "") {
                    this.cover.ImageUrl = 'https://grouptogethersite.blob.core.windows.net/siteres/giphy-front-cover.png';
                }
            }
        },

        beforeUnmount: function () {
            document.removeEventListener('click', this.handleClickOutside);
            document.removeEventListener('gif-selected', this.handleGifSelected);
            document.removeEventListener('ai-magic-cover-generated', this.handleAiMagicCoverGenerated);
        },

        methods: {
            // GTD-7755: swap a broken cover image (e.g. a user upload that now 404s) to the
            // default cover placeholder so the on-screen card view doesn't show a broken image.
            onCoverImageError(event) {
                const img = event.target
                if (img.dataset.gcFallbackApplied) return
                img.dataset.gcFallbackApplied = '1'
                img.src = 'https://grouptogethersite.blob.core.windows.net/siteres/giphy-front-cover.png'
            },
            handleClickOutside(event) {
                const coverDiv = this.$refs.coverDivRef;
                const textEditorBlock = document.getElementById('textEditorBlock');

                // Check if the click is outside the current component's div
                if (this.isCoverEditable
                    && coverDiv
                    && !coverDiv.contains(event.target)
                    && (!textEditorBlock || !textEditorBlock.contains(event.target))) {
                    this.resetEditableMode();
                }
            },
            handleDivClick() {
                if (this.templateClass != '_giphy_front_cover_') {
                    this.editImage();
                }
            },
            handleGifSelected(event) {
                const imageUrl = event.detail?.images?.original?.url || event.detail?.images?.fixed_height?.url;
                if (!imageUrl) return;
                this.cover.ImageUrl = imageUrl;
                this.cover.GcPdfImage = event.detail.images.original_still.url;
                this.saveData();
            },
            handleAiMagicCoverGenerated(event) {
                // Handle AI Magic Cover generated event from parent component
                if (event.detail && event.detail.imageUrl) {
                    // Update cover.ImageUrl with AI generated image for _ai-magic-cover_ template
                    if (this.templateClass.includes('_ai-magic-cover_')) {
                        this.cover.ImageUrl = event.detail.imageUrl;

                        // Handle layout change - update ClassName
                        if (event.detail.layout) {
                            let baseClassName = this.cover.ClassName.replace(/\s*ai-full-cover\s*/g, '').trim();

                            if (event.detail.layout === 'withOutTitle') {
                                // Add ai-full-cover class if not present
                                if (!baseClassName.includes('ai-full-cover')) {
                                    this.cover.ClassName = baseClassName + ' ai-full-cover';
                                }
                            } else {
                                // Remove ai-full-cover class
                                this.cover.ClassName = baseClassName;
                            }
                        }

                        this.saveDataWithoutReload();
                    } else {
                        this.saveData();
                    }
                }
            },
            openAiMagicCover(isEditMode) {
                // Emit event to parent to open AI Magic Cover modal
                this.$emit('open-ai-magic-cover', isEditMode);
            },
            editImage() {
                if (this.editable) {
                    this.popupType = 3
                    this.$refs.imageInputEdit.click()
                }
            },
            loadImageinBoxCover() {
                let input = this.$refs.imageInputEdit;
                this.groupCardCoverContainer = "groupCardCoverContainer";
                this.$emit('UserCropperContainer', this.groupCardCoverContainer);

                // Error if image size exceeds 5MB limit
                if (input.files[0].size > 5242880) {
                    $("#image_large_popup").modal();
                    $("#imageContainer").html($("#imageContainer").html());
                    return;
                }

                if (input.files[0] == undefined) return;
                $('#imageCropperContainer').modal('show');

                let reader = new FileReader();
                reader.addEventListener("load", () => {
                    window.src = reader.result;
                    this.cover.ImageUrl = reader.result; // Set the image URL
                    $('._image_upload_input_').val('');
                }, false);

                if (input.files[0]) {
                    reader.readAsDataURL(input.files[0]);
                }
            },
            deleteImage() {
                event.stopPropagation();
                this.cover.GcPdfImage = null;
                this.cover.ImageUrl = null;
            },
            handleImageSelectClick(event) {
                event.stopPropagation();
                $("#giphy-library").modal();
                $(".modal-backdrop").addClass("z-index-50");
            },
            onInputCoverDescEdit(event) {
                const htmlVal = event.target.innerHTML
                this.editedDescriptionM = htmlVal
            },
            onInputCoverEdit(event) {
                const htmlVal = event.target.innerHTML
                this.editedTitleM = htmlVal
            },
            closePopup() {
                this.popupType = 0
                this.popupText = ""
                this.popupTitle = ""
                this.showCoverDiv = false
            },
            setFocus(element) {
                $(element).focus();
            },
            editCoverTitle() {
                if (this.editable && this.popupType !== 1) {
                    this.popupType = 1
                    this.$nextTick(() => {
                        this.placeCaretAtEndCoverDiv()
                    })
                }
            },
            editCoverDesc() {
                if (this.editable) {
                    this.popupType = 2
                    this.$nextTick(() => {
                        this.placeCaretAtEndCoverDescDiv()
                    })
                }
            },
            resetEditableMode() {
                this.popupType = 0
            },
            placeCaretAtEndCoverDiv(el) {
                var el = this.$refs.coverDivRef
                this.$refs.coverDivRef.focus()
                if (typeof window.getSelection != "undefined"
                    && typeof document.createRange != "undefined") {
                    var range = document.createRange();
                    range.selectNodeContents(el);
                    range.collapse(false);
                    var sel = window.getSelection();
                    sel.removeAllRanges();
                    sel.addRange(range);
                } else if (typeof document.body.createTextRange != "undefined") {
                    var textRange = document.body.createTextRange();
                    textRange.moveToElementText(el);
                    textRange.collapse(false);
                    textRange.select();
                }
            },
            placeCaretAtEndCoverDescDiv(el) {
                var el = this.$refs.coverDescDivRef
                this.$refs.coverDescDivRef.focus()
                if (typeof window.getSelection != "undefined"
                    && typeof document.createRange != "undefined") {
                    var range = document.createRange();
                    range.selectNodeContents(el);
                    range.collapse(false);
                    var sel = window.getSelection();
                    sel.removeAllRanges();
                    sel.addRange(range);
                } else if (typeof document.body.createTextRange != "undefined") {
                    var textRange = document.body.createTextRange();
                    textRange.moveToElementText(el);
                    textRange.collapse(false);
                    textRange.select();
                }
            },
            handlePaste(event) {
                event.preventDefault()
                const text = event.clipboardData.getData('text/plain')
                document.execCommand('insertText', false, text)
            },
            async saveData() {
                let coverTitle = this.cover.Title
                let coverDesc = this.cover.Description
                let coverImage = this.cover.ImageUrl

                // If title is edited OR not null
                if (this.popupType === 1 || this.editedTitleM !== this.cover.Title) {
                    coverTitle = this.editedTitleM;
                }

                // If description is edited OR not null
                if (this.popupType === 2 || this.editedDescriptionM) {
                    coverDesc = this.editedDescriptionM;
                }

                // If image source is updated or not null
                const imageSrc = this.cover?.ImageUrl || $("._image_upload_img_").attr("src")
                if (this.popupType === 3 || imageSrc) {
                    coverImage = imageSrc;
                }

                this.characterCounter = this.characterLength(coverTitle)
                if (this.characterCounter > 150) {
                    this.showErrorPopup("Maximum message length is 150 characters.");
                    return false
                }

                //creating sending object
                let coverObj = {
                    Collection: this.collection,
                    Title: coverTitle,
                    FontSize: this.FontSize,
                    TextAlign: this.textReAlign,
                    DescTextAlign: this.descriptionTextAlign,
                    DescFontSize: this.descriptionFontSize,
                    Description: coverDesc,
                    ImageUrl: coverImage,
                    CoverType: this.cover.CoverType,
                    ContentType: this.cover.ContentType,
                    ClassName: this.cover.ClassName,
                    CardUrl: this.cover.CardUrl,
                    GcPdfImage: this.cover.GcPdfImage
                }

                //create save request
                const requestOptions = {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(coverObj)
                };
                await fetch('/api/collectionservices/update-groupcard-cover', requestOptions)
                    .then((res) => res.json())
                    .then((data) => {
                        if (data.StatusCode === 1) {
                            this.closePopup()

                            // Only reload if NOT AI Magic Cover template
                            if (!this.templateClass.includes('_ai-magic-cover_')) {
                                location.reload()
                            }
                        }
                    })
                    .catch(err => console.log(err.message))
            },
            async saveDataWithoutReload() {
                let coverTitle = this.cover.Title
                let coverDesc = this.cover.Description
                let coverImage = this.cover.ImageUrl

                // If title is edited OR not null
                if (this.popupType === 1 || this.editedTitleM) {
                    coverTitle = this.editedTitleM;
                }

                // If description is edited OR not null
                if (this.popupType === 2 || this.editedDescriptionM) {
                    coverDesc = this.editedDescriptionM;
                }

          // For upload/crop flow, ImageCropper updates the DOM img src directly.
         // For GIF selection flow, cover.ImageUrl is updated in-memory and should be saved as-is.
                if (this.popupType === 3) {
                const imageSrc = $("._image_upload_img_").attr("src")
                    if (imageSrc) {
                                coverImage = imageSrc;
                                this.cover.ImageUrl = imageSrc;
                            }
                }

                this.characterCounter = this.characterLength(coverTitle)
                if (this.characterCounter > 150) {
                    this.ShowErrorPopUp("Maximum message length is 150 characters.");
                    return false
                }

                //creating sending object
                let coverObj = {
                    Collection: this.collection,
                    Title: coverTitle,
                    FontSize: this.FontSize,
                    TextAlign: this.textReAlign,
                    DescTextAlign: this.DescriptionTextAlign,
                    DescFontSize: this.DescriptionFontSize,
                    Description: coverDesc,
                    ImageUrl: coverImage,
                    CoverType: this.cover.CoverType,
                    ContentType: this.cover.ContentType,
                    ClassName: this.cover.ClassName,
                    CardUrl: this.cover.CardUrl,
                    GcPdfImage: this.cover.GcPdfImage
                }

                //create save request
                const requestOptions = {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(coverObj)
                };
                await fetch('/api/collectionservices/gcupdatecover', requestOptions)
                    .then((res) => res.json())
                    .then((data) => {
                        if (data.StatusCode === 1) {
                            this.closePopup()
                        }
                    })
                    .catch(err => console.log(err.message))
            },
            stripHtml(html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var textContent = doc.body.textContent || "";
                return textContent
            },
            showErrorPopup(message) {
                document.getElementById("error-text").innerHTML = message;
                $("#mt-generic-error-popup").modal();
            },
            characterLength(html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var textContent = doc.body.textContent || "";
                var characterCount = textContent.length;
                return characterCount
            }
        },
        computed: {
            templateClass() {
                return this.cover.ClassName
            },
            coverTypeClass() {
                if (this.cover.CoverType === 2) {
                    return 'groupCardDescription'
                } else if (this.cover.CoverType === 3) {
                    return 'groupCardImage'
                } else {
                    return ''
                }
            },
            isCoverEditable() {
                return (this.editable && this.popupType === 1)
            },
            isDescEditable() {
                return (this.editable && this.popupType === 2)
            },
            isImageEditable() {
                return (this.editable && this.popupType === 3)
            },
            hasAiMagicCoverImage() {
                // For AI Magic Cover template, check if cover.ImageUrl exists and is not the placeholder
                if (this.templateClass.includes('_ai-magic-cover_')) {
                    return this.cover?.ImageUrl &&
                        this.cover.ImageUrl !== this.placeholderImageUrl &&
                        this.cover.ImageUrl !== '' &&
                        this.cover.ImageUrl !== 'https://grouptogethersite.blob.core.windows.net/siteres/giphy-front-cover.png';
                }
                return false;
            }


        }
    }
</script>
<!-- script -->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .show-this-div {
        display: block;
    }

    .gc-close-modal {
        z-index: 999999;
    }

    a.edit-card.edit-gc-title {
        position: absolute;
        top: 80px;
        right: -35px;
        background-color: #7fe2dc;
        width: 64px;
        height: 64px;
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 0 10px rgb(37 37 37 / 25%);
    }

        a.edit-card.edit-gc-title svg {
            width: 28px;
            height: 28px;
            fill: #fff;
        }

    .gc-booklet div[contenteditable="true"] {
        border: 2px dashed;
        padding: 5px 0;
    }

    @media screen and (max-width: 767px) {
        a.edit-card.edit-gc-title {
            top: auto;
            right: 0;
            width: 50px;
            height: 50px;
            bottom: -35px;
            left: 0;
            margin: 0 auto;
        }

            a.edit-card.edit-gc-title svg {
                width: 22px;
                height: 22px;
                fill: #fff;
            }
    }
</style>
